import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import roundToPrecision from '../../utils/roundToPrecision';

import { OptionListStyle } from './OptionListStyle';

const OptionList = ({ theme, shape, options, width }) => {
  const optionStyle = useMemo(() => {
    if (options?.length) {
      const width = roundToPrecision(100 / options?.length, 2);

      return {
        width: `${width}%`,
        flexBasis: `${width}%`,
        WebkitFlexBasis: `${width}%`,
      };
    }

    return null;
  }, [options?.length]);

  if (options?.length) {
    return (
      <OptionListStyle className={`${theme}-theme ${shape}-shape`} style={{width: `${width}%` }}>
        {options?.map((option) => {
          if (option?.content && option?.onClick) {
            return (
              <button
                key={option?.key}
                className={`option-item-button${
                  option?.active ? ' active' : ''
                }`}
                type="button"
                style={optionStyle}
                disabled={option?.disabled}
                onClick={option?.onClick}
              >
                {option?.content}
              </button>
            );
          }

          if (option?.content && !option?.onClick) {
            return (
              <div
                key={option?.key}
                className="option-item-content"
                style={optionStyle}
              >
                {option?.content}
              </div>
            );
          }

          return null;
        })}
      </OptionListStyle>
    );
  }

  return null;
};

OptionList.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      active: PropTypes.bool,
      content: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.node,
      ]),
      disabled: PropTypes.bool,
      key: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      onClick: PropTypes.func,
    })
  ),
  shape: PropTypes.string,
  theme: PropTypes.string,
  width: PropTypes.number,
};

OptionList.defaultProps = {
  options: [],
  shape: 'rounded',
  theme: 'default',
};

export default OptionList;
